<n-slide-window *ngIf="pageReady" [visible]="windowVisible" [width]="SWITCH.IS_SIMPLE_MODE ? '6.08rem' : '7rem'" (onHide)="close()">
    <n-header>
        <h1>{{data.subType === ShareTypeE.Homedir ? i18n.title.modifyHomedirTitle : i18n.title.modifyShare}}</h1>
        <n-help-link key="cifsModify" *ngIf = "!SWITCH.IS_SIMPLE_MODE"></n-help-link>
        <n-help-link key="simplifycifsManage" *ngIf="SWITCH.IS_SIMPLE_MODE"></n-help-link>
    </n-header>

    <form [errorMessage]="errorMessage" [formGroup]="vm" [simpleMode]="SWITCH.IS_SIMPLE_MODE"
        [ngClass]="{ 'form-width-simple': SWITCH.IS_SIMPLE_MODE, 'common-form': !SWITCH.IS_SIMPLE_MODE }">
        <!-- 共享名称 -->
        <n-form-item [required]="false" [label]="i18n.label.share_name">
            <div id="modify-cifs-share-name" class="n-form-item-text text-wrap">{{data.NAME || this.UNPLACEHOLDER}}</div>
        </n-form-item>
        <!-- 共享路径，只展示 -->
        <n-form-item [required]="false" [label]="data.subType === ShareTypeE.Homedir ? i18n.label.relative_path : i18n.label.share_path">
            <div id="modify-cifs-share-share_path" class="n-form-item-text text-wrap">{{data.SHAREPATH || this.UNPLACEHOLDER}}</div>
        </n-form-item>
        <!-- homedir -->
        <n-form-item [label]="i18n.label.homedir">
            <span>{{data.subType === ShareTypeE.Homedir ? i18n.value.yes : i18n.value.no}}</span>
        </n-form-item>
        <!-- 描述 -->
        <n-form-item [label]="i18n.label.description">
            <textarea id="modify-cifs-share-description"
                nTextarea
                formControlName="DESCRIPTION"
                [placeholder]="errorMessage.DESCRIPTION.rangeByteLength">
            </textarea>
        </n-form-item>
        <!-- notify -->
        <n-form-item [label]="i18n.label.notify"
            [helpContent]="i18n.tip.notify">
            <n-checkbox id="modify-cifs-share-notify"
                style="margin-left: auto;"
                [label]="i18n.label.enable"
                formControlName="ENABLENOTIFY">
            </n-checkbox>
        </n-form-item>
        <!-- 是否启用CA -->
        <n-form-item [label]="i18n.label.enableCa"
            [helpContent]="i18n.tip.enableCa">
            <n-checkbox id="create-cifs-share-show-enable-ca"
                style="margin-left: auto;"
                [label]="i18n.label.enable"
                formControlName="ENABLECA">
            </n-checkbox>
        </n-form-item>
        <!-- 是否启用SMB3加密 -->
        <n-form-item [label]="i18n.label.smb3EncryptionEnable"
            [helpContent]="i18n.tip.smb3EncryptionEnable">
            <n-checkbox id="create-cifs-share-show-smb3EncryptionEnable"
                style="margin-left: auto;"
                [label]="i18n.label.enable"
                formControlName="smb3EncryptionEnable">
            </n-checkbox>
        </n-form-item>
        <!-- 是否启用拒绝非加密客户端访问 -->
        <n-form-item [label]="i18n.label.unencryptedAccess"
            [helpContent]="i18n.tip.unencryptedAccess">
            <n-checkbox id="create-cifs-share-show-unencryptedAccess"
                style="margin-left: auto;"
                [label]="i18n.label.enable"
                formControlName="unencryptedAccess">
            </n-checkbox>
        </n-form-item>
        <!-- 是否启用ABE -->
        <n-form-item [label]="i18n.label.ABE"
            [helpContent]="i18n.tip.ABE">
            <n-checkbox id="modify-cifs-share-ABE"
                style="margin-left: auto;"
                [label]="i18n.label.enable"
                formControlName="ABEENABLE">
            </n-checkbox>
        </n-form-item>
        <!-- 显示以前的版本 -->
        <n-form-item [label]="i18n.label.showPreviousVersion"
            [helpContent]="i18n.label.showPreviousVersionTip">
            <n-checkbox id="create-cifs-share-enableShowPreviousVersion"
                [label]="i18n.label.enable"
                formControlName="ENABLESHOWPREVIOUSVERSIONS">
            </n-checkbox>
        </n-form-item>
        <!-- 显示Snapshot -->
        <n-form-item [label]="i18n.label.showSnapShotLab"
            [helpContent]="i18n.label.showSnapShotTip">
            <n-checkbox id="modify-cifs-share-enableShowSnapshot"
                [label]="i18n.label.enable"
                formControlName="ENABLESHOWSNAPSHOT">
            </n-checkbox>
        </n-form-item>
        <!-- 离线文件缓存模式 -->
        <n-form-item [label]="i18n.label.offlineCacheModeLab"
            [helpContent]="i18n.tip.offLineFileModeTip"
            *ngIf="data.ID !== '0'">
            <n-select id="modify-cifs-share-offLineFileMode"
                [options]="str.fileModeOpts"
                formControlName="OFFLINEFILEMODE">
            </n-select>
        </n-form-item>
    </form>

    <n-footer>
        <button id="modify-cifs-share-ok-btn" nButton theme="primary" [label]="i18n.btn.okBtn" (click)="onOk()">
        </button>
        <button id="modify-cifs-share-cancel-btn" nButton [label]="i18n.btn.cancelBtn" (click)="hide()">
        </button>
    </n-footer>
</n-slide-window>
